<template>
  <div>
    <button class="el_button" :style="styles">
      <div class="el_button_text" :style="styles" @click="lintTo">
        {{ text }}
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TopButton',
  props: {
    text: {
      type: String,
    },
    color: {
      type: String,
      default: '#ffa4a4',
    },
    link: {
      default: null,
    },
    fontSize: {},
    padding: {},
    enabled: {
      type: Boolean,
      default: true,
    }
  },
  watch: { 
    enabled: function(newVal, oldVal) {
      this.statusColor = newVal ? this.color : '#999999' 
    }
  },
  data() {
    return {
      statusColor: this.enabled ? this.color : '#999999'
    }
  },  
  computed: {
    styles() {
      return {
        '--font-size': this.fontSize,
        '--padding': this.padding,
        '--color': this.statusColor,
      }
    }
  },
  methods: {
    lintTo() {
      if (this.enabled && this.link != null) {
        this.$router.push(this.link)
      }
    },
  },
}
</script>

<style scoped>
.el_button {
  --font-size: 31px;
  --color: ffa4a4;
  background: var(--color);
  border: none;
  border-radius: 61.5px;

  font-style: normal;
  font-weight: bold;
  font-size: var(--font-size);
  line-height: 45px;
  /* identical to box height */

  color: #ffffff;
  transition: 1s;
}
.el_button:hover {
  transform: scale(1.1);
}
.el_button_text {
  --padding: 35px;
  padding: var(--padding);
  color: #ffffff;
}
</style>
